import type {
  MiniappToParentNotificationInputOf,
  ParentToMiniappNotificationInputOf,
} from "schemas/miniappRpc";

import { useSyncExternalStore } from "react";

import { parentRemote } from "./miniappRpc";

type CommandMenuState =
  ParentToMiniappNotificationInputOf<"setCommandMenuState">;
const closedState: CommandMenuState = { open: false, query: "" };
let state = closedState;
const listeners = new Set<() => void>();
let opener: HTMLElement | null = null;

export function setCommandMenuState(next: CommandMenuState) {
  if (state.open === next.open && state.query === next.query) {
    return;
  }
  state = next;
  for (const listener of listeners) {
    listener();
  }
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Host search state, isolated from the miniapp's page and data contexts. */
export function useCommandMenu() {
  return useSyncExternalStore(
    subscribe,
    () => state,
    () => closedState,
  );
}

export function openCommandMenu(
  options?: MiniappToParentNotificationInputOf<"openCommandMenu">,
) {
  if (!state.open) {
    opener =
      document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null;
  }
  parentRemote.openCommandMenu(options);
}

export function restoreCommandMenuFocus() {
  const target = opener;
  opener = null;
  if (target?.isConnected && document.activeElement === document.body) {
    target.focus({ preventScroll: true });
  }
}
